module.exports = __webpack_public_path__ + "static/media/discoverIcon.c8084182.svg";